import { PortfolioSourcesService_portfolioSourcesServiceGetStops } from '@festina/unitlink-general-types/unitlink/hooks/PortfolioSourcesStopsService_portfolioSourcesServiceGetStops'

export const useFetchPortfolioStopHistory =
  PortfolioSourcesService_portfolioSourcesServiceGetStops.useQuery
